import i18n from 'i18next';
import {DataStatus, showNotification} from 'platform/components';

import {useParams} from 'react-router-dom';

import {useApplySharedPresetMutation} from '@dms/api/core';
import {dashboardRoutes} from '@dms/routes';
import {handleApiError} from '@dms/shared';

import {isSafeUrl, useNavigate, useOnMount, useQueryState} from 'shared/web';

export function SharePreset() {
  const {code, sharedPresetId} = useParams();
  const [q] = useQueryState('q');
  const [applySharedPresetMutation, {isLoading, isError}] = useApplySharedPresetMutation();
  const navigate = useNavigate();

  useOnMount(() => {
    const redirectUrl = q;

    if (code && sharedPresetId && redirectUrl) {
      applySharedPresetMutation({
        code,
        applySharedPresetRequestBody: {
          sharedPresetId,
        },
      })
        .unwrap()
        .then(() => {
          showNotification.success(i18n.t('general.notifications.presetApplied'));
          navigate(isSafeUrl(redirectUrl) ? decodeURIComponent(redirectUrl) : dashboardRoutes.home);
        })
        .catch(handleApiError);
    }
  });
  return <DataStatus isLoading={isLoading} isError={isError} />;
}
